/* MelkyPro — apparition au défilement et carrousel des avis. */
(() => {
  /* Le contenu est visible par défaut. Un élément n'est masqué (puis animé à son arrivée à l'écran)
     qu'une fois que le navigateur a confirmé qu'il se trouve hors de l'écran. */
  const observer =
    'IntersectionObserver' in window && !window.Shopify?.designMode
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const el = entry.target;
              if (entry.isIntersecting) {
                el.classList.remove('is-pending');
                el.classList.add('is-in');
                observer.unobserve(el);
              } else if (!el.classList.contains('is-in') && entry.boundingClientRect.top > 0) {
                el.classList.add('is-pending');
              }
            });
          },
          { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
        )
      : null;

  const reveal = (root = document) => {
    if (!observer) return;
    root.querySelectorAll('.mk-reveal:not(.is-in)').forEach((el) => observer.observe(el));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => reveal());
  } else {
    reveal();
  }
  document.addEventListener('shopify:section:load', (event) => reveal(event.target));

  if (!customElements.get('mk-slider')) {
    customElements.define(
      'mk-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.mk-slider__track');
          this.prev = this.querySelector('.mk-slider__nav--prev');
          this.next = this.querySelector('.mk-slider__nav--next');
          if (!this.track) return;

          this.update = this.update.bind(this);
          this.prev?.addEventListener('click', () => this.move(-1));
          this.next?.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
          this.addEventListener('shopify:block:select', (event) => {
            event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          });
          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        move(direction) {
          const slide = this.track.firstElementChild;
          if (!slide) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: direction * (slide.offsetWidth + gap), behavior: 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max;
        }
      }
    );
  }

  /* Bouton « remonter au bloc d'achat » de la page produit */
  const buyTarget = () =>
    document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"]');

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mk-scroll-buy]');
    const target = trigger && buyTarget();
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* Questions fréquentes : accordéon accessible */
  if (!customElements.get('mk-faq')) {
    customElements.define(
      'mk-faq',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const button = event.target.closest('.mk-faq__q');
            if (button) this.toggle(button.closest('.mk-faq__item'));
          });
          this.addEventListener('shopify:block:select', (event) => {
            const item = event.target.closest('.mk-faq__item');
            if (item && !item.classList.contains('is-open')) this.toggle(item);
          });
        }

        toggle(item) {
          const open = !item.classList.contains('is-open');
          if (open && this.hasAttribute('data-single')) {
            this.querySelectorAll('.mk-faq__item.is-open').forEach((other) => this.set(other, false));
          }
          this.set(item, open);
        }

        set(item, open) {
          item.classList.toggle('is-open', open);
          item.querySelector('.mk-faq__q')?.setAttribute('aria-expanded', String(open));
        }
      }
    );
  }
  /* Bundle : la couleur choisie dans une offre affiche l'image associée à cette variante */
  const fileOf = (src) => (src || '').split('/').pop().split('?')[0];
  let variantFiles = null;
  const getVariantFiles = async () => {
    if (variantFiles) return variantFiles;
    const response = await fetch(`${window.location.pathname.replace(/\/$/, '')}.js`);
    const product = await response.json();
    variantFiles = Object.fromEntries(
      (product.variants || []).filter((v) => v.featured_image).map((v) => [String(v.id), fileOf(v.featured_image.src)])
    );
    return variantFiles;
  };

  const showVariantMedia = async (variantId) => {
    const gallery = document.querySelector('product-media-gallery');
    if (!gallery || !window.location.pathname.includes('/products/')) return;
    const file = (await getVariantFiles().catch(() => ({})))[String(variantId)];
    if (!file) return;
    const slides = [...gallery.querySelectorAll('.product-media-gallery__media')];
    const index = slides.findIndex((slide) => fileOf(slide.querySelector('img')?.getAttribute('src')) === file);
    if (index < 0) return;
    const slider = gallery.querySelector('slider-component');
    if (slider?.slider?.go) slider.slider.go(index);
    else gallery.querySelectorAll('.product-media-gallery__thumbnail')[index]?.click();
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest('quantity-breaks select');
    if (select && /^\d+$/.test(select.value)) showVariantMedia(select.value);
  });
  /* Avis Judge.me : les avis avec photos s'affichent en premier */
  const sortReviewsPicturesFirst = () => {
    let tries = 0;
    const timer = setInterval(() => {
      const select = document.querySelector('.jdgm-review-widget select');
      if (!select) {
        if (++tries > 60) clearInterval(timer);
        return;
      }
      clearInterval(timer);
      if (select.dataset.mkSorted) return;
      select.dataset.mkSorted = 'true';
      const hasOption = [...select.options].some((option) => option.value === 'pictures_first');
      if (!hasOption || select.value === 'pictures_first') return;
      select.value = 'pictures_first';
      select.dispatchEvent(new Event('change', { bubbles: true }));
      if (window.jQuery) window.jQuery(select).trigger('change');
    }, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortReviewsPicturesFirst);
  } else {
    sortReviewsPicturesFirst();
  }
})();
/* Avis Judge.me : masque les photos d'avis listées dans les paramètres du thème
   (photos qui ne montrent pas le produit : colis, emballage, image vide…). */
(() => {
  const ids = (window.mkHiddenReviewPhotos || [])
    .map((line) => line.trim().split('/').pop().split('?')[0].replace(/\.(jpe?g|png|webp|gif)$/i, ''))
    .filter((id) => id.length > 5);
  if (!ids.length) return;

  const isHidden = (src) => ids.some((id) => src.includes(id));
  const hideImage = (img) => {
    const src = img.currentSrc || img.src || img.getAttribute('data-src') || '';
    if (!src || !isHidden(src)) return;
    const holder = img.closest('button, a, li, [role="button"]');
    const target = holder && holder.querySelectorAll('img').length === 1 ? holder : img;
    target.style.setProperty('display', 'none', 'important');
  };
  const scan = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.tagName === 'IMG') hideImage(root);
    root.querySelectorAll('img').forEach(hideImage);
  };

  const start = () => {
    scan(document.body);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') hideImage(mutation.target);
        else mutation.addedNodes.forEach(scan);
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
